import './utils/polyfill'
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import './element-ui'
import App from './App'
import router from './router'
import store from './store'
import titleMixin from './utils/title-mixin'
import TLayout from './components/tech/tech-layout.vue'
import IEcharts from 'vue-echarts-v3/src/full.js'

Vue.config.productionTip = false

// 全局混合
Vue.mixin(titleMixin)

// 布局组件
Vue.component('t-layout', TLayout)
Vue.component('v-echarts', IEcharts)

// 将路由数据同步到store中，通过this.$store.route可以访问、只读
sync(store, router)

// 存储初始状态的state，退出登录后用于重置state
sessionStorage.setItem('initState', JSON.stringify(store.state))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js